import { where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";
import { useCollection } from "functions/hooks/useCollection";
import { User, SquareArrowOutUpRightIcon } from "lucide-react";
import { ViewMgtDeviceStatusValue } from "./ViewMgtDeviceStatusValue";

export default function ViewMgtDeviceStatusClient({ deviceId }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {

  const navigate = useNavigate();
  const [user, setUser] = useState<any>(null);
  const [userId, setUserId] = useState<any>(null);
  const usersCollection = useCollection<any>('users');
  const vehiclesCollection = useCollection<any>('vehicles');

  useEffect(() => {
    (async () => {
      const response = await vehiclesCollection.queryOne([where('deviceId', '==', deviceId)]);   
      if (response?.data?.userId) {
        setUserId(response.data.userId);
        setUser(await usersCollection.getOne(response.data.userId));
      }
    })();
  }, [deviceId]);
  
  return (
    <ViewMgtDevicePanel title="Client" icon={ <User size={16} />} topRight={userId && <a style={{cursor:'pointer'}} onClick={() => navigate(`/agent/clients/${userId}/account/view`)} title='Go to Client'><SquareArrowOutUpRightIcon/></a>}>
      <div className="grid grid-cols-1 gap-0">
        
        <ViewMgtDeviceStatusValue
          label="First Name"
          value={user?.profile?.firstName}
          color={"text-state-500"}
          timestamp={"-"}
          />

        <ViewMgtDeviceStatusValue
          label="Last Name"
          value={user?.profile?.lastName}
          timestamp={"-"}
          color={"text-state-500"}
          />

        <ViewMgtDeviceStatusValue
          label="Email"
          value={user?.profile?.email}
          color={"text-state-500"}
          timestamp={"-"}
          />

        <ViewMgtDeviceStatusValue
          label="Phone"
          value={user?.profile?.phoneCode && user?.profile?.phoneNumber ? `+${user?.profile?.phoneCode}${user?.profile?.phoneNumber}` : ''}
          color={"text-state-500"}
          timestamp={"-"}
          />

      </div>
    </ViewMgtDevicePanel>
  );
}
